import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgbDropdownModule, NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { SidebarModule } from "ng-sidebar";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { CollapseModule, ModalModule } from "ngx-bootstrap";
// ------------------------------------------SharedComponent----------------------------------------------------------------------//
import { HeaderComponent } from "./header/header.component";
import { JubiliSidebarComponent } from "./jubili-sidebar/jubili-sidebar.component";
import { CompanyEditModalComponent } from "./jubili-edit-modal/company-edit-modal.component";
import { AddressInformationComponent } from "./jubili-address/address-information.component";
import { BuilkSidebarComponent } from "./builk-sidebar/builk-sidebar.component";
import { JubiliEditExpireCompanyComponent } from "./jubili-edit-expire-company/jubili-edit-expire-company.component";
import { ConfirmModalComponent } from "./confirm-modal/confirm-modal.component";
import { PipeModule } from '../../pipe/pipe.module';
import { ProvincePipe } from '../../pipe/address/province.pipe';
import { ProvinceEntryComponent } from './province-entry-component/province.entry.component';
import { JubiliImageInTableComponent } from './jubili-image-in-table/jubili-image-in-table.component';
import { JubiliEditFeatureModalComponent } from './jubili-edit-feature-modal/jubili-edit-feature-modal.component';
import { JubiliLpmEditModalComponent } from "./jubili-lpm-edit-modal/jubili-lpm-edit-modal.component";
import { JubiliEditCompanyFormModalComponent } from './jubili-edit-company-form-modal/jubili-edit-company-form-modal.component';
import { JubiliFormSelectorComponent } from './jubili-form-selector/jubili-form-selector.component';
import { NgSelectModule } from "@ng-select/ng-select";
import { SuccessModalComponent } from './success-modal/success-modal.component';
import { IntakeSidebarComponent } from "./intake-sidebar/intake-sidebar.component";
import { ToastComponent } from './toast/toast.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        NgbModule.forRoot(),
        SidebarModule.forRoot(),
        NgbDropdownModule,
        BsDropdownModule.forRoot(),
        CollapseModule.forRoot(),
        ModalModule.forRoot(),
        ReactiveFormsModule,
        PipeModule,
        NgSelectModule
    ],
    declarations: [
        HeaderComponent,
        JubiliSidebarComponent,
        CompanyEditModalComponent,
        JubiliEditFeatureModalComponent,
        AddressInformationComponent,
        BuilkSidebarComponent,
        JubiliEditExpireCompanyComponent,
        ConfirmModalComponent,
        ProvinceEntryComponent,
        JubiliImageInTableComponent,
        JubiliLpmEditModalComponent,
        JubiliEditCompanyFormModalComponent,
        JubiliFormSelectorComponent,
        SuccessModalComponent,
        IntakeSidebarComponent,
        ToastComponent
    ],
    exports: [
        HeaderComponent,
        JubiliSidebarComponent,
        CompanyEditModalComponent,
        JubiliEditFeatureModalComponent,
        AddressInformationComponent,
        BuilkSidebarComponent,
        JubiliEditExpireCompanyComponent,
        ConfirmModalComponent,
        ProvinceEntryComponent,
        JubiliImageInTableComponent,
        JubiliLpmEditModalComponent,
        JubiliEditCompanyFormModalComponent,
        NgSelectModule,
        SuccessModalComponent,
        IntakeSidebarComponent,
        BsDropdownModule,
        ToastComponent
    ],
    providers: [
        ProvincePipe
    ],
    entryComponents: [
        ProvinceEntryComponent
    ]
})

export class SharedModule { }
